export const API_BASE = "https://xufv-o1wb-gken.n7.xano.io/api";
export const imageUploadURL = `${API_BASE}:LiqXQBP3/upload/image`;
// export const S3UploadImageURL = "http://localhost:5001";
export const S3UploadImageURL = "https://devnode.umicard.com";
export const CRMURL = "https://devnode.umicard.com/crm";
export const StripeNode = "https://devnode.umicard.com/stripe";
